import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type IllustrationOnTheLeftLayoutProps = {
  illustration: React.ReactNode;
  children: React.ReactNode;
};
export function IllustrationOnTheLeftLayout(t0) {
  const $ = _c(7);
  const {
    illustration,
    children
  } = t0;
  let t1;
  if ($[0] !== illustration) {
    t1 = <div className="order-2 flex justify-center lg:order-1"><div className="w-full max-w-xl">{illustration}</div></div>;
    $[0] = illustration;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="order-1 mx-auto max-w-xl lg:order-2">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-10">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}